import { GetAllContentsInDto, GetAllContentsOutDto } from '../../../types/content.dto'

export const GET_ALL_CUSTOM_CONTENT_TYPES = 'GET_ALL_CUSTOM_CONTENT_TYPES'
export const GET_ALL_CUSTOM_CONTENT_TYPES_SUCCESS = 'GET_ALL_CUSTOM_CONTENT_TYPES_SUCCESS'
export const GET_ALL_CUSTOM_CONTENT_TYPES_ERROR = 'GET_ALL_CUSTOM_CONTENT_TYPES_ERROR'
export const RESET_GET_ALL_CUSTOM_CONTENT_TYPES = 'RESET_GET_ALL_CUSTOM_CONTENT_TYPES'

export interface GetAllCustomContentTypes {
  type: typeof GET_ALL_CUSTOM_CONTENT_TYPES
  payload: GetAllContentsOutDto
}

export interface GetAllCustomContentTypesSuccess {
  type: typeof GET_ALL_CUSTOM_CONTENT_TYPES_SUCCESS
  payload: GetAllContentsInDto
}

export interface GetAllCustomContentTypesError {
  type: typeof GET_ALL_CUSTOM_CONTENT_TYPES_ERROR
  payload: string | boolean
}

export interface ResetGetAllCustomContentTypes {
  type: typeof RESET_GET_ALL_CUSTOM_CONTENT_TYPES
  payload: null
}

export interface State {
  data: GetAllContentsInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | GetAllCustomContentTypes
  | GetAllCustomContentTypesSuccess
  | GetAllCustomContentTypesError
  | ResetGetAllCustomContentTypes
